import { Link } from 'react-router-dom';
import Battery from 'components/Battery/Battery';
import ScooterPreview from 'components/ScooterPreview/ScooterPreview';
import batteryToMiles from 'helpers/battery-to-miles';
import styles from './ScooterCard.module.scss';

export default function ScooterCard({ scooter }) {
  return (
    <Link to={`/scooters/${scooter.id}`} className={styles.container}>
      <div className={styles.preview}>
        <ScooterPreview model={scooter?.kind} inline />
      </div>
      
      <div className={styles.id}>
        #{scooter?.id}
      </div>

      <div className={styles.rangeWrap}>
        <div>
          {batteryToMiles(scooter?.battery ?? 0)} MI
        </div>
        <div className={styles.range}>
          <Battery value={scooter?.battery} /> RANGE
        </div>
      </div>
    </Link>
  )
}